<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-input v-model="query.no" clearable placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" clearable placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        :column-config="{resizable: true}"
        :scroll-x="{enabled: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.no" width="200"/>
        <vxe-column field="name" title="business.label.name" width="400"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="getDetail(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { Role } from '@/api/dto/admin/Role'

export default {
  name: 'RoleList',
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      query: new Role(),
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('roleFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new Role(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new Role()
      this.refresh()
    },
    getDetail(row) {
      this.$emit('getDetail', row)
    },
    add() {
      this.$emit('add')
    }
  }
}
</script>